// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__CEx3f","image":"Header_image__2n_pT","name":"Header_name__3JLYt","info":"Header_info__1yF_o","infoRow":"Header_infoRow__11Sit"};